import { ROLES } from "../../../../../../../constnats/user";
import AuthService from "../../../../../../../service/auth";
import { BLOCK_TYPE } from "../../../../constants/generalConstants";
import { BlockType } from "../../../../types";

export function getBlocksToRender(blocks: BlockType[]): BlockType[] {
    let blocksToRender = blocks;
    // if user is not an admin they should see only table blocks
    if (!AuthService.hasGlobalRole(ROLES.ADMIN)) {
        blocksToRender = blocksToRender.filter((block) => block.type === BLOCK_TYPE.TABLE);
    }

    return blocksToRender;
}